




















































import {
  defineComponent
} from '@nuxtjs/composition-api';
import Separator from "~/components/Palmers/PageBuilder/Element/Separator.vue";
import PageBuilderElement from "~/components/Palmers/PageBuilder/PageBuilderElement.vue";


export default defineComponent({
  name: 'ElementAccordion',
  components: {
    Separator,
    PageBuilderElement
  },
  props: {
    element: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      activeTab: (this.element?.active_sections ? [parseInt(this.element.active_sections) - 1] : this.element?.at_least_one_open ? [0] : [null]) as any[]
    }
  },
  methods: {
    changeActiveTab(index) {
      if(this.activeTab.includes(index)) {
        const indexToRemove = this.activeTab.indexOf(index);
        if(this.element?.at_least_one_open && this.activeTab.length === 1) return
        this.activeTab.splice(indexToRemove, 1);
      }else if(this.element.collapsible_all) {
        this.activeTab.push(index)
      }else {
        this.activeTab = [index]
      }
    },
    getPanelStyles() {
      const styles = {};

      if(this.element.section_background_color) {
        styles['background-color'] = this.element.section_background_color;
      }

      if(this.element.section_background_color) {
        styles['color'] = this.element.section_color;
      }

      if(this.element.section_border_width) {
        styles['border-width'] = `${this.element.section_border_width}px`;
      }

      return styles;
    },
    getHeadingStyles() {
      const styles = {};

      if(this.element.title_font_size) {
        styles['font-size'] = `${this.element.title_font_size}px`;
      }

      return styles;
    },
    getPanelBodyStyles() {
      const styles = {};

      if(this.element.no_fill_content_area && !this.element?.section_content_background_color) {
        styles['background-color'] = 'transparent'
      }

      if(this.element.section_content_background_color) {
        styles['background-color'] = `${this.element.section_content_background_color}`
      }

      return styles;
    }
  }
});
